import { render, staticRenderFns } from "./CreateSchool.vue?vue&type=template&id=0d0b1450&scoped=true"
import script from "./CreateSchool.vue?vue&type=script&lang=js"
export * from "./CreateSchool.vue?vue&type=script&lang=js"
import style0 from "./CreateSchool.vue?vue&type=style&index=0&id=0d0b1450&lang=css"
import style1 from "./CreateSchool.vue?vue&type=style&index=1&id=0d0b1450&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0b1450",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d0b1450')) {
      api.createRecord('0d0b1450', component.options)
    } else {
      api.reload('0d0b1450', component.options)
    }
    module.hot.accept("./CreateSchool.vue?vue&type=template&id=0d0b1450&scoped=true", function () {
      api.rerender('0d0b1450', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/CreateSchool.vue"
export default component.exports